module.exports = __webpack_public_path__ + "images/cic.png?v=de2656e073978d7d3076bbb0c340a2ca";